import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";
import { faq } from "@/data/site";

export default function FAQ() {
  return (
    <section className="py-24 md:py-32">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <Reveal className="text-center">
          <p className="text-xs tracking-[0.35em] uppercase text-brand-gold mb-4">FAQ</p>
          <h2 className="font-heading font-light text-4xl md:text-5xl text-brand-black">Domande frequenti</h2>
        </Reveal>
        <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
          {faq.map((item, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-brand-ivory">
              <AccordionTrigger data-testid={`faq-${i}`} className="text-left font-heading text-xl text-brand-black hover:text-brand-olive hover:no-underline py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-brand-brown leading-relaxed text-base">{item.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
